export const RoutesNames = {
  // propertyView: '/properties/:id',
  // properties: '/properties',
  intro: '/intro',
  units: '/units',
  animals: '/animals',
  resetPassword: '/reset-password',
  settings: '/settings',
  animalComplaint: '/animal-complaints/:id',
};
